import { Button } from "@/components/ui/button";

type BoardCardProps = {
  id: string;
  name: string;
  emoji: string;
  isDefault: boolean;
  onDelete: (id: string) => void;
};

export const BoardCard = ({ id, name, emoji, isDefault, onDelete }: BoardCardProps) => {
  return (
    <div className="p-4 border rounded-lg space-y-2">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-2">
          <span className="text-2xl">{emoji}</span>
          <h3 className="font-medium">{name}</h3>
        </div>
        {!isDefault && (
          <Button
            variant="destructive"
            size="sm"
            onClick={() => onDelete(id)}
          >
            Delete
          </Button>
        )}
      </div>
    </div>
  );
};